import { PartnerType } from 'legacy/lut/classes/models/PartnerType'
import { Dropdown } from 'legacy/lut/library/dropdown'
import { useCallback, useMemo } from 'react'
import { useSelector } from 'react-redux'

import { selectRoles } from 'core-components/sitebuilder/store/selectors/selectRoles'
import { Static } from 'core-components/types'
import { Crud } from 'core/types/Crud'

import { TRANSLATION_KEYS } from '../../../../translations/TRANSLATION_KEYS'

import { values, valuesForNotSuperAdmin } from './configs'

interface IProps {
  value: PartnerType
  onChange: (value: string) => void
  className?: string
}

export const PartnersTypeSelect = ({ value, onChange, className }: IProps) => {
  const roles = useSelector(selectRoles)
  const isSuperAdmin = roles.some((el) => el.id === 'SuperAdmin')

  const source = useMemo(() => {
    const data = isSuperAdmin ? values : valuesForNotSuperAdmin
    return new Crud({
      fetcher: new Static(data),
      keyField: 'value',
    })
  }, [isSuperAdmin])

  const handleChange = useCallback(
    (value: string) => {
      onChange(value)
    },
    [onChange]
  )

  return (
    <Dropdown
      classes={{
        controlClasses: {
          root: className,
        },
      }}
      translation={TRANSLATION_KEYS.partnersTypeField}
      value={value as string}
      source={source}
      caption={'label'}
      onChange={handleChange}
    />
  )
}
